export const EmailSettingTypes = {
  ReplyTo: 'emails_reply_to',
  AutoApproval: 'approval_notification_ccs',
  CustomSignature: 'custom_email_signature_id'
};

const emailSettingDetails = {
  [EmailSettingTypes.ReplyTo]: {
    title: 'Reply-To',
    description: 'By turning this setting on and providing an email address, when a recipient clicks the "Reply" '
      + 'button in their email client to respond to an email sent through PINS, the email client will use the address '
      + 'provided in this setting as the default recipient for the reply.'
  },
  [EmailSettingTypes.AutoApproval]: {
    title: 'Automatic Insurance Approval Email',
    description: 'PINS will automatically generate an email notifying recipients that their'
        + ' insurance has been Approved.'
  },
  [EmailSettingTypes.CustomSignature]: { description: 'Your custom signature will appear automatically in all your outgoing emails.' }
};

export const getSettingDetails = type => {
  if (!emailSettingDetails[type]) {
    throw new Error(`setting type of ${type} does not exist`);
  }

  return emailSettingDetails[type];
};
